module.exports = __webpack_public_path__ + "img/0Q3A5610_L_BlackMatted_MockedUp.8029b81d.jpg";